import * as React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import TripCreate from './TripCreate';
import TripEdit from './TripEdit';
import TripList from './TripList';

const TripPage = (props) => {
    let { path } = useRouteMatch();
    const [lastURLParams, setLastURLParams] = React.useState(new URLSearchParams(window.location.search));

    return (
        <Switch>
            <Route path={`${path}/create`}>
                <TripCreate {...props} />
            </Route>
            <Route path={`${path}/:id/:tab/:subtab/:user_id/:api_filters`}>
                <TripEdit lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id/:tab/:subtab/:api_filters`}>
                <TripEdit lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id/:tab/:subtab`}>
                <TripEdit lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id/:tab`}>
                <TripEdit lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route path={`${path}/:id`}>
                <TripEdit lastURLParams={lastURLParams} {...props} />
            </Route>
            <Route exact path={path}>
                <TripList setLastURLParams={setLastURLParams} {...props} />
            </Route>
        </Switch>
    );
};

export default TripPage;
